const CxQuestion = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="20" height="20" rx="4" fill="#FFB423"/>
<path d="M7.28004 7.02667C6.74671 6.8 6.52004 6.14 6.84004 5.66C7.48671 4.7 8.56671 4 9.99338 4C11.56 4 12.6334 4.71333 13.18 5.60667C13.6467 6.37333 13.92 7.80667 13.2 8.87333C12.4 10.0533 11.6334 10.4133 11.22 11.1733C11.12 11.3533 11.06 11.5 11.02 11.8C10.96 12.2867 10.56 12.6667 10.0667 12.6667C9.48671 12.6667 9.01338 12.1667 9.08004 11.5867C9.12004 11.2467 9.20004 10.8933 9.38671 10.56C9.90004 9.63333 10.8867 9.08667 11.46 8.26667C12.0667 7.40667 11.7267 5.8 10.0067 5.8C9.22671 5.8 8.72004 6.20667 8.40671 6.69333C8.17338 7.07333 7.68671 7.19333 7.28004 7.02667ZM11.3334 15.3333C11.3334 16.0667 10.7334 16.6667 10 16.6667C9.26671 16.6667 8.66671 16.0667 8.66671 15.3333C8.66671 14.6 9.26671 14 10 14C10.7334 14 11.3334 14.6 11.3334 15.3333Z" fill="white"/>
</svg>

  );
};  

export default CxQuestion;
